/* eslint-disable */
import axios from "axios";
import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { MaterialReactTable } from "material-react-table";
import { useListing } from "../providers/ListingsProvider";
function FavoriteR() {

  const { favoriteListings, getFavoriteListings, handleFavorite } = useListing();
  const navigate = useNavigate();

  const handleDelete = async (id, is_favorite) => {
    try {
      handleFavorite(id, is_favorite).then(() => {
        getFavoriteListings();
      });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };


  const columns = useMemo(
    () => [
      {
        accessorKey: "id",
        header: "ID",
        size: 150,
      },
      // {
      //   accessorKey: "images",
      //   header: "Image",
      //   size: 150,
      //   Cell: ({ row }) => (
      //     <img
      //       src={row.original.images?.[0].image}
      //       alt="Host"
      //       style={{ width: "50px", height: "50px", borderRadius: "50%" }}
      //     />
      //   ),
      // },

      {
        accessorKey: "listing.title",
        header: "Title",
        size: 200,
      },

      {
        accessorKey: "listing.no_of_bedrooms",
        header: "Bedrooms",
        size: 150,
      },
      {
        accessorKey: "listing.no_of_bathrooms",
        header: "Bathrooms",
        size: 150,
      },
      {
        accessorKey: "listing.no_of_guest",
        header: "Guests",
        size: 150,
      },

      {
        accessorKey: "action",
        header: "Action",
        size: 200,
        Cell: ({ row }) => (
          <div className="flex gap-2">
            <select
              className="shadow-md bg-white cursor-pointer p-[10px] rounded border-soft"
              onChange={(e) => {
                const action = e.target.value;
                if (action === "view") {
                  navigate(`/listing/${row.original.listing_id}`); // Navigate to the listing page
                } else if (action === "remove") {
                  handleDelete(row.original.id, true);
                  getFavoriteListings();// Trigger the delete function
                }
              }}
              defaultValue="" // Default value for the dropdown
            >
              <option value="">
                Action
              </option>
              <option value="view">View</option>
              <option value="remove">Remove</option>
            </select>
          </div>
        ),
      },
    ],
    []
  );

  return (
    <div className="px-4">
      <div className="dashboard-title my-4">
        <h3>My Favorites</h3>
      </div>
      <div>
        <MaterialReactTable
          columns={columns}
          data={favoriteListings}
          muiPaginationProps={{
            rowsPerPageOptions: [
              { value: 10, label: "10" },
              { value: 25, label: "25" },
              { value: 50, label: "50" },
              { value: 100, label: "100" },
              { value: favoriteListings?.length, label: "All" },
            ],
            showFirstButton: false,
            showLastButton: false,
          }}
        />
      </div>
    </div>
  );
}

export default FavoriteR;
